import React, {useMemo} from "react";
import {isEmpty} from "lodash";
import {Card, Col, Row} from "reactstrap";
import {useSelector} from "react-redux";
import SafeView from "../../../components/safeView/SafeView";
import Tabs from "../../../components/Tabs/Tabs";
import {useTabNavigation} from "../../../hooks/useTabNavigation";
import {getUserProfile} from "../../../redux/Selectors/users.selector";
import Overview from "../Overview/overview";
import {getTabList} from "./controllerDetailsTabs";
import {useGetIoTypes} from "./useGetIoTypes";
import "./controllerDetails.scss";

function ControllersDetails() {
  const {ioTypes, appliance_type} = useGetIoTypes();
  const {activeTab} = useTabNavigation();
  const userProfile = useSelector(getUserProfile);

  const TabList = useMemo(
    () => getTabList(userProfile?.is_superuser),
    [userProfile?.is_superuser]
  );

  const tabsList = useMemo(() => {
    let tabList = TabList;
    if (isEmpty(ioTypes)) {
      tabList = tabList.filter((tab) => tab.key !== "summary");
    }
    return tabList;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TabList, appliance_type, ioTypes]);

  const defaultActiveTab = activeTab || tabsList[0]?.key;

  return (
    <SafeView>
      <Row className="controller-details-container">
        <Col xl="3" className="controller-overview-container">
          <Overview ioTypes={ioTypes} />
        </Col>
        <Col className="mb-5 mb-xl-0" xl="9">
          <Card className="shadow">
            <Tabs
              defaultActive={defaultActiveTab}
              ioTypes={ioTypes}
              key={defaultActiveTab}
              list={tabsList}
            />
          </Card>
        </Col>
      </Row>
    </SafeView>
  );
}

export default ControllersDetails;
